export const TITLE_BUTTON_DATA_HOOK = 'textBlockStyleButton_Title';
